export default "__VITE_ASSET__64573213__"